<script>
import Loading from '../../components/loading.vue';
import StudyList from '../../components/studyList.vue';

export default {
    name: "studyList",
    data() {
        return {
            list: [],
            page: 1,
            allPage: 1,
            isLoading: false,
        };
    },
    computed: {},
    components: {
        StudyList,
        Loading
    },
    mounted() {},
    destroyed() {},
    watch: {
        '$route': {
            handler: function () { 
                this.list = [];
                this.getData();
            },
            immediate: true
        }
    },
    methods: {
        getData() {
            this.isLoading = true;
            this.$store.dispatch('getStudyList', {
                category_id: this.$route.query.id,
                limit: 6,
                page: this.page
            }).then((result) => {
                this.isLoading = false;
                if (result.code == 100) { 
                    this.list = this.list.concat(result.data.list);
                    this.allPage = result.data.last_page;
                }
            }).catch((err) => {
                this.isLoading = false;
            });
        },
        getMore() { 
            if (this.isLoading) { 
                return false;
            }
            this.page++;
            this.getData();
        }
    },
};
</script>

<template>
    <div class="study_list">
        <StudyList :data="list"/>
        <Loading v-if="isLoading"/>
        <p class="no_more" v-else-if="list.length == 0">暂无更多内容</p>
        <p class="no_more" v-else-if="page == allPage">已经到底了</p>
        <div class="flex justify_center" v-else>
            <div class="layout_btn_more" @click="getMore">更多课程</div>
        </div>
    </div>
</template>

<style scoped lang="scss">
.study_list{
    .layout_btn_more{
        // font-size: .2rem;
        color: #666;
        border-bottom: 1px solid #666;
        margin-top: .5rem;
        cursor: pointer;
    }
}
</style>